/****************************************************************************************************
* hoem -> page-home > email
****************************************************************************************************/


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// let hoemIsSnippet = true;
// if(hoemIsSnippet && typeof hoemIsRevert !== 'undefined') {
//   hoemScrollClear();
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Variables & Functions
let hoemSel = '.sector.email ';

let brainShapeColors = ['#989898', '#e3e3e3', '#cbcbcb', '#ebebeb', '#d5d5d5', '#e0e0e0'];
let brainShapeLen = 2914;
let brainLinesLen = [451, 28, 363, 32, 397, 279, 65, 251, 1227, 539, 442, 461, 891, 394, 1479, 174, 1136, 386, 322, 796, 864, 671];
let brainRouteLen = 2054;
let stepsDistPxl = [2054, 1653, 1314, 985, 657, 317, 0];
let stepsDistSec = [0.00, 1.95, 3.60, 5.20, 6.80, 8.46, 10.00];

const getElOffsetH = (elSel) => document.querySelector(elSel).offsetHeight;

const getStepsInfo = (len, steps) => {
  let info = [];
  steps.forEach((item, index) => {
    let distPixel = len - item;
    let distPortion = distPixel / len;
    let distPercent = distPortion * 100;
    info.push([distPixel, distPortion, distPercent.toFixed(2)])
  });
  return info;
}
// let info = getStepsInfo(brainRouteLen, stepsDist);
// console.log(info.reduce((a, c) => a + ', ' + c[0], ''));
// console.log(info.reduce((a, c) => a + ', ' + c[1], ''));
// console.log(info.reduce((a, c) => a + ', ' + c[2], ''));



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Scroll & Animation

let hoemTitle; // eslint-disable-line no-unused-vars
let hoemScrollTl1; // eslint-disable-line no-unused-vars
let hoemScrollTl2; // eslint-disable-line no-unused-vars
let hoemScrollTl3; // eslint-disable-line no-unused-vars
// let hoemCopyTl; // eslint-disable-line no-unused-vars
let hoemEmailOnTl; // eslint-disable-line no-unused-vars
let hoemBrainStepAni; // eslint-disable-line no-unused-vars
let hoemButterflyRouteTl; // eslint-disable-line no-unused-vars
let hoemStepsTl; // eslint-disable-line no-unused-vars
let hoemScrollTl4; // eslint-disable-line no-unused-vars

const hoemInit = (gsapRef, splitTextRef) => {
  gsapRef.set("#gr-ho-em-brain2", { attr: { gradientTransform: "rotate(80)" }});

  gsapRef.set('.sector.email .container-in', {autoAlpha: 0, y: -window.innerHeight});
  gsapRef.set('.sector.email .contents-wrapper', {y: 0});

  gsapRef.set('.sector.email .email-bg-1-in', {backgroundPosition: '50% 0%'});
  gsapRef.set('.sector.email .email-bg:not(.email-bg-1)', {top: '0%', opacity: 0});
  gsapRef.set('.sector.email .email-bg-in:not(.email-bg-1-in)', {'--email-bg-play-state': 'paused'});

  gsapRef.set('.sector.email .sector-copies-in', {clearProps: 'all'});
  gsapRef.set('.sector.email .sector-copies-in', {top: '50vh', y: '-50%'});
  hoemTitle = new splitTextRef('.sector.email .sector-copy.title .copy span', {type: 'chars,words', charsClass:'char char++'});
  gsapRef.set('.sector.email .sector-copy.title .copy span .char', {transformOrigin: 'left center', autoAlpha: 0, rotationX: '70deg', y: '20%', x: '-70%'});
  gsapRef.set('.sector.email .sector-copy.sentance .copy span', { autoAlpha: 0,  y: '70%'});

  gsapRef.set('.sector.email .email-brain-in', {scale: 3});
  gsapRef.set('.sector.email #brain-shape', {strokeDasharray: brainShapeLen, strokeDashoffset: brainShapeLen});
  gsapRef.set('#gr-ho-em-brain2 .gr-ho-em-brain-stop', {stopColor: i => brainShapeColors[i] + '00'});
  gsapRef.set('.sector.email .brain-line-path', {strokeWidth: '10px', strokeDasharray: i => brainLinesLen[i], strokeDashoffset: i => brainLinesLen[i]});
  gsapRef.set('.sector.email .brain-route-mask-use', {strokeDasharray: brainRouteLen, strokeDashoffset: brainRouteLen});
  gsapRef.set('.sector.email .brain-step-g', {transformOrigin: 'center center', scale: 0});
  
  document.querySelectorAll(`.sector.email .email-step`).forEach(el => el.classList.remove('active'));
  gsapRef.set('.sector.email .email-steps-in', {y: 0});
  gsapRef.set('.sector.email .email-step-bar .bar1', {scaleX: 0});
  gsapRef.set('.sector.email .step-dot-in', {scale: 0});

  gsapRef.set('.sector.email .butterfly-vector', {'--butterfly-play-state': 'paused'});
  gsapRef.set('.sector.email .butterfly-vector', {opacity: 0});
  gsapRef.set('.sector.email .butterfly-vector-in', {rotation: 90});
}

const hoemScrollMake = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  
  // Getting Y length to pin the element inside the sector
  const getElPinYPx = (sector) => getElOffsetH(sector) - (getElOffsetH(sector) - window.innerHeight);

  ////////// Scroll 1: Pin over web & during email
  let scrollDur1 = window.innerHeight;
  let scrollDur2 = getElOffsetH('.sector.email .container-in');

  hoemScrollTl1 = gsapRef.timeline({
    defaults: {ease: 'none'},
    scrollTrigger: {
      id: 'hoemScrollTl1',
      trigger: hoemSel,
      toggleActions: 'restart complete reverse reset',
      start: 'top bottom',
      end: 'bottom top',
      scrub: true,
      toggleClass: 'scroll-active-hoemScrollTl1',
      invalidateOnRefresh: true,
      // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0}
      // onEnter: (self) =>{},
      // onLeave: (self) => {},
      // onEnterBack: (self) => {},
      // onLeaveBack: (self) => {},
      // onUpdate: (self) => console.log(`${self.vars.id}: onUpdate:`, self.progress.toFixed(3)),
      // onToggle: (self) => console.log(`${self.vars.id}: onToggle:`, self.isActive)
    }
  })
  .addLabel('t0', 0)
  .to('.sector.email .container-in', {duration: scrollDur1, y: 0})
  .to('.sector.email .container-in', {duration: scrollDur2, y: getElPinYPx('.sector.email')}, scrollDur1)
  ;

  ////////// Scroll 2: Pin during email
  hoemScrollTl2 = gsapRef.timeline({
    defaults: {ease: 'none'},
    scrollTrigger: {
      id: 'hoemScrollTl2',
      trigger: hoemSel,
      toggleActions: 'restart complete reverse reset',
      start: 'top top',
      end: 'bottom top' ,
      scrub: true,
      toggleClass: 'scroll-active-hoemScrollTl2',
      invalidateOnRefresh: true,
      // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0}
      // onEnter: (self) =>{},
      // onLeave: (self) => {},
      // onEnterBack: (self) => {},
      // onLeaveBack: (self) => {},
      // onUpdate: (self) => console.log(`${self.vars.id}: onUpdate:`, self.progress.toFixed(3)),
      // onToggle: (self) => console.log(`${self.vars.id}: onToggle:`, self.isActive)
    }
  })
  .addLabel('t0', 0)
  .to('.sector.email .email-bg-1-in', {backgroundPosition: '50% 100%'}, 0)
  .to('.sector.email .email-steps-in', {y: () => getElOffsetH('.sector.email .container-in') - window.innerHeight}, 0)
  ;

  ////////// Scroll 3: Pin under graphic: Pin .contents-wrapper, not .container-in (if pin this, conflict with other pin)
  let pinEmUnderGr = 0.5;
  hoemScrollTl3 = gsapRef.timeline({
    defaults: {ease: 'none'},
    scrollTrigger: {
      id: 'hoemScrollTl3',
      trigger: hoemSel,
      toggleActions: 'restart complete reverse reset',
      start: 'bottom top',
      end: () => `+=${pinEmUnderGr * 100}%`,
      scrub: true,
      toggleClass: 'hoemScrollTl3-active',
      invalidateOnRefresh: true,
      // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0}
      // onEnter: (self) =>{},
      // onLeave: (self) => {},
      // onEnterBack: (self) => {},
      // onLeaveBack: (self) => {},
      // onUpdate: (self) => console.log(`${self.vars.id}: onUpdate:`, self.progress.toFixed(3)),
      // onToggle: (self) => console.log(`${self.vars.id}: onToggle:`, self.isActive)
    }
  })
  .addLabel('t0', 0)
  .to('.sector.email .contents-wrapper', {y: '+='+ (window.innerHeight * pinEmUnderGr)}) 
  ;

  ////////// Copy on
//   hoemCopyTl = gsapRef.timeline({
//     scrollTrigger:{
//       id: 'hoemCopyTl',
//       trigger: hoemSel,
//       start: 'top 0.5%',
//       end: '+=0',
//       toggleActions: 'restart none reverse none',
//       onEnter: (self) => {
//         smootherRef.paused(true);
//       },
//       // onLeave: (self) => {},
//       onEnterBack: (self) => {
//         // smootherRef.paused(true);
//       },
//       // onLeaveBack: (self) => {},
//     },
//     // onStart: () => {},
//     onComplete: () => { smootherRef.paused(false); },
//     // onReverseComplete: () => { smootherRef.paused(false); }
//   })
//   .to(hoemSel+' .sector-copy.title .copy .char', {duration: 0.3, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger: 0.05, ease: 'power2.out'}, 0)
//   .to(hoemSel+' .sector-copy.sentance .copy span', {duration: 0.5, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger:0.1, ease: 'back.out(2)'}, '-=0.25');

  ////////// Email on
  hoemBrainStepAni = [1,2,3,4,5,6,7].map(i => gsapRef.to(`.sector.email .brain-step-g.step${i}`,
    {paused: true, duration: 0.3, scale: 1.1, ease: 'back.out(2)'}))

  const stepSetActive = (cur, dir) => {
    document.querySelectorAll(`.sector.email .email-step`)
      .forEach(el => el.classList.remove('active'));

    if(dir === 1) { // Forward
      if(cur !== 0){
        document.querySelectorAll(`.sector.email .step${cur}`)
          .forEach(el => el.classList.add('active'));
        hoemBrainStepAni[cur-1].play();
      }
    } else { // Backward
      if(cur === 0) {
        hoemBrainStepAni[1].reverse();
      } else {
        if(cur !== 1) document.querySelectorAll(`.sector.email .step${cur-1}`)
          .forEach(el => el.classList.add('active'));
        hoemBrainStepAni[cur-1].reverse();
      }
    }
  }

  hoemEmailOnTl = gsapRef.timeline({
    scrollTrigger:{
      id: 'hoemEmailOnTl',
      trigger: hoemSel,
      start: 'top top',
      end: '+=0',
      toggleActions: 'restart none reverse none',
      onEnter: (self) => {
        smootherRef.paused(true);
        gsapRef.set('.sector.email .butterfly-vector', {'--butterfly-play-state': 'running'});
        gsapRef.set('.sector.email .email-bg-in:not(.email-bg-1-in)', {'--email-bg-play-state': 'running'});
      },
      // onLeave: (self) => {},
      onEnterBack: (self) => {
        smootherRef.paused(true);
      },
      // onLeaveBack: (self) => {},
    },
    // onStart: () => {},
    onComplete: () => {
      smootherRef.paused(false);
    },
    onReverseComplete: () => {
      smootherRef.paused(false);
      gsapRef.set('.sector.email .butterfly-vector', {'--butterfly-play-state': 'paused'});
      gsapRef.set('.sector.email .email-bg-in:not(.email-bg-1-in)', {'--email-bg-play-state': 'paused'});
    }
  })
  .addLabel('t0', 0)
    
  .to('.sector.email .container-in', {duration: 0.5, autoAlpha: 1, ease: 'power1.in'})

  .to('.sector.email .sector-copy.title .copy span .char', {duration: 0.3, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger: 0.05, ease: 'power2.out'}, 0.3)
  .to('.sector.email .sector-copy.sentance .copy span', {duration: 0.5, autoAlpha: 1, rotationX: '0deg', y: '0%', x: '0%', stagger:0.1, ease: 'back.out(2)'}, '-=0.25')

  .to('.sector.email .brain-line-path', {duration: 1, strokeDashoffset: 0, ease: 'none'}, '-=0.8')

  .addLabel('t1')
  
  .to('.sector.email .email-brain-in', {duration: 0.7, scale: 1, ease: 'power2.inOut'}, 't1')
  .to('#gr-ho-em-brain2 .gr-ho-em-brain-stop', {duration: 0.5, stopColor: i => brainShapeColors[i] + 'ff', ease: 'power1.inOut'}, '-=0.2')
  .to('.sector.email .brain-line-path', {duration: 0.5, strokeWidth: '4px', ease: 'none'}, '-=0.3')
  .to('.sector.email #brain-shape', {duration: 1.2, strokeDashoffset: 0, ease: 'none'}, '-=0.5')
  
  .to('.sector.email .sector-copies-in', {duration: 1, top: '0vh', y: '0%', ease: 'power2.inOut'}, 't1')

  .addLabel('t2')

  .add(() => {
    // let brainStep1Rect = document.querySelector('.sector.email .brain-step-g.step1').getBoundingClientRect();
    // let butterflyRect = document.querySelector('.sector.email .butterfly-vector').getBoundingClientRect();
    // gsapRef.set('.sector.email .butterfly-vector', {x: (brainStep1Rect.x-butterflyRect.width*0.82)+'px',
    //   y: (brainStep1Rect.y-butterflyRect.height*0.73)+'px', rotateZ: '-133.83deg', transformOrigin: '80% 50%'});
    
    if(hoemButterflyRouteTl) return;
    console.log('[home:email] hoemButterflyRouteTl created');
    hoemButterflyRouteTl = gsapRef.to('.sector.email .butterfly-vector-01', {
      id: 'hoemButterflyRouteTl', paused: true, duration: 10, ease: 'none', motionPath: {
        path: '#brain-route-path', align: '#brain-route-path', alignOrigin: [0.65, 0.5], autoRotate: true}});
    hoemButterflyRouteTl.progress(0);

    if(hoemScrollTl4.getChildren(true, true, true).includes(hoemButterflyRouteTl)) hoemScrollTl4.remove(hoemButterflyRouteTl);
    hoemScrollTl4.add(hoemButterflyRouteTl, 'tButterflyRoute');
    hoemButterflyRouteTl.paused(false);
    console.log('[home:email] hoemButterflyRouteTl added');

  }, 't2-=0.2')

  .to('.sector.email .email-bg:not(.email-bg-1)', {duration: 0.6, opacity: 1, stagger: 0.3, ease: 'power1.in'}, 't2-=1.5')  

  .to('.sector.email .email-step-bar .bar1', {duration: 0.4, scaleX: 1, ease: 'power1.inOut'}, 't2-=0.5')
  .to('.sector.email .step-dot-in', {duration: 0.3, scale: 1, ease: 'none'}, 't2-=0.3')

  .add(() => stepSetActive(0, hoemEmailOnTl.scrollTrigger.direction), 't2')
  .add(() => stepSetActive(1, hoemEmailOnTl.scrollTrigger.direction), 't2+=0.3')

  .to('.sector.email .butterfly-vector', {duration: 0.5, opacity: 1, ease: 'power1.inOut'}, '+=0.5')    
  ;

  ////////// After Email on: Steps
  const stepsDelay = 0.5;
  
  let hoemStepsTlDir;
  hoemStepsTl = gsapRef.timeline({
    defaults: {ease: 'none'},
    scrollTrigger: {
      id: 'hoemStepsTl',
      trigger: hoemSel,
      toggleActions: 'restart complete reverse reset',
      start: 'top -0.01%',
      end: 'bottom top' ,
      scrub: true,
      // snap: 'labelsDirectional',
      toggleClass: 'hoemStepsTl-active',
      invalidateOnRefresh: true,
      // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0}
      // onEnter: (self) =>{},
      // onLeave: (self) => {},
      // onEnterBack: (self) => {},
      // onLeaveBack: (self) => {},
      // onUpdate: (self) => {},
      onUpdate: (self) => {
        if (self.direction !== hoemStepsTlDir) {
          if (self.direction === 1) {
            gsapRef.to('.sector.email .butterfly-vector-in', {duration: 0.3, rotation: 90, overwrite: 'auto', ease: 'power1.inOut'})
          } else {
            gsapRef.to('.sector.email .butterfly-vector-in', {duration: 0.3, rotation: 270, overwrite: 'auto', ease: 'power1.inOut'})
          }
          hoemStepsTlDir = self.direction;
        }
      },
      // onToggle: (self) => console.log(`${self.vars.id}: onToggle:`, self.isActive)
    }
  })
  .addLabel('tRoute', stepsDelay)
  .addLabel('tStep', stepsDelay-0.1) // Make a little faster than route

  // .addLabel('tStep2', 'tStep+='+stepsDistSec[1])
  // .addLabel('tStep3', 'tStep+='+stepsDistSec[2])
  // .addLabel('tStep4', 'tStep+='+stepsDistSec[3])
  // .addLabel('tStep5', 'tStep+='+stepsDistSec[4])
  // .addLabel('tStep6', 'tStep+='+stepsDistSec[5])
  // .addLabel('tStep7', 'tStep+='+stepsDistSec[6])

  .to('.sector.email .brain-route-mask-use', {duration: 10, strokeDashoffset: 0}, 'tRoute')

  // .add(() => stepSetActive(0, hoemStepsTl.scrollTrigger.direction), 'tStep') // Do it on Email on
  // .add(() => stepSetActive(1, hoemStepsTl.scrollTrigger.direction), 'tStep+='+stepsDistSec[0]) // Do it on Email on
  .add(() => stepSetActive(2, hoemStepsTl.scrollTrigger.direction), 'tStep+='+stepsDistSec[1])
  .add(() => stepSetActive(3, hoemStepsTl.scrollTrigger.direction), 'tStep+='+stepsDistSec[2])
  .add(() => stepSetActive(4, hoemStepsTl.scrollTrigger.direction), 'tStep+='+stepsDistSec[3])
  .add(() => stepSetActive(5, hoemStepsTl.scrollTrigger.direction), 'tStep+='+stepsDistSec[4])
  .add(() => stepSetActive(6, hoemStepsTl.scrollTrigger.direction), 'tStep+='+stepsDistSec[5])
  .add(() => stepSetActive(7, hoemStepsTl.scrollTrigger.direction), 'tStep+='+stepsDistSec[6])

  .add(()=>{}, stepsDelay+10+1) // Give some space before & after total duration(10sec) for steps
  ;

  ////////// After Email on: Scroll, start, end, duration are same as Email On
  hoemScrollTl4 = gsapRef.timeline({
    defaults: {ease: 'none'},
    scrollTrigger: {
      id: 'hoemScrollTl4',
      trigger: hoemSel,
      toggleActions: 'restart complete reverse reset',
      start: 'top -0.01%',
      end: 'bottom top' ,
      scrub: 3,
      // snap: 'labels',
      toggleClass: 'hoemScrollTl4-active',
      invalidateOnRefresh: true,
      // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0}
      // onEnter: (self) =>{},
      // onLeave: (self) => {},
      // onEnterBack: (self) => {},
      // onLeaveBack: (self) => {},
      // onUpdate: (self) => {},
      // onToggle: (self) => console.log(`${self.vars.id}: onToggle:`, self.isActive)
    }
  })
  .addLabel('t1', stepsDelay)
  .addLabel('tButterflyRoute', stepsDelay)

  .add(() => {
    // if(!hoemButterflyRouteTl || hoemScrollTl4.getChildren(true, true, true).includes(hoemButterflyRouteTl)) return;
    // console.log('[home:email] hoemButterflyRouteTl added');
    // if(hoemScrollTl4.getChildren(true, true, true).includes(hoemButterflyRouteTl)) hoemScrollTl4.remove(hoemButterflyRouteTl);
    // hoemScrollTl4.add(hoemButterflyRouteTl, 'tButterflyRoute');
    // hoemButterflyRouteTl.paused(false);
  }, 'tButterflyRoute')

  .to("#gr-ho-em-brain2", { duration: stepsDistSec[6], attr: { gradientTransform: "rotate(30)" }, ease: "none" }, 0)
  .to(".sector.email .email-bg-2", { duration: stepsDistSec[6], top: '-70%', scale: 1.2, ease: "none" }, 0)
  .to(".sector.email .email-bg-3", { duration: stepsDistSec[6], top: '-90%', scale: 1.2, ease: "none" }, 0)
  .to(".sector.email .email-bg-4", { duration: stepsDistSec[6], top: '-110%', scale: 1.2, ease: "none" }, 0)

  .add(()=>{}, stepsDelay+10+1) // Give some space before & after total duration(10sec) for steps
  ;
}

const hoemScrollClear = () => { 
  if(hoemTitle) { hoemTitle.revert(); hoemTitle = null; }
  if(hoemScrollTl1) { hoemScrollTl1.revert(); hoemScrollTl1 = null; }
  if(hoemScrollTl2) { hoemScrollTl2.revert(); hoemScrollTl2 = null; }
  if(hoemScrollTl3) { hoemScrollTl3.revert(); hoemScrollTl3 = null; }
  // if(hoemCopyTl) { hoemCopyTl.revert(); hoemCopyTl = null; }
  if(hoemEmailOnTl) { hoemEmailOnTl.revert(); hoemEmailOnTl = null; }
  if(hoemBrainStepAni) { hoemBrainStepAni.forEach(tl => tl.revert()); hoemBrainStepAni = null; }
  if(hoemButterflyRouteTl) { hoemButterflyRouteTl.revert(); hoemButterflyRouteTl = null; }
  if(hoemStepsTl) { hoemStepsTl.revert(); hoemStepsTl = null; }
  if(hoemScrollTl4) { hoemScrollTl4.revert(); hoemScrollTl4 = null; }
}


////////// Code for snippet
// if(hoemIsSnippet) {
//   hoemInit(gsap, splitTextRef);
//   hoemScrollMake(gsap, scrollTrigger, smoother, splitText);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Elements Animation Control
const hoemElsControl = (opt='play') => {
  if(opt === 'play') {
    document.querySelectorAll('.sector.email .butterfly-vector').forEach( el =>
      el.style.setProperty('--butterfly-play-state', 'running'));
    document.querySelectorAll('.sector.email .email-bg-in:not(.email-bg-1-in)').forEach( el =>
      el.style.setProperty('--email-bg-play-state', 'running'));
  } else {
    document.querySelectorAll('.sector.email .butterfly-vector').forEach( el =>
      el.style.setProperty('--butterfly-play-state', 'paused'));
    document.querySelectorAll('.sector.email .email-bg-in:not(.email-bg-1-in)').forEach( el =>
      el.style.setProperty('--email-bg-play-state', 'paused'));
  }
}


  
////////////////////////////////////////////////////////////////////////////////////////////////////
/// Resizing

const hoemResizeStart = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  console.log("[home email] Resize: START");
}

const hoemResizeDone = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  console.log("[home email] Resize: END");

  hoemScrollClear();
  hoemInit(gsapRef, splitTextRef);
  hoemScrollMake(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
}

////////// Code for snippet
// let hoemResizing = false;
// const hoemResizeHandler = (e) => {
//   if(!hoemResizing) {
//     hoemResizing = true;
//     smootherRef.paused(true);
//     scrollTriggerRef.disable();

//     hoemResizeStart(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }

//   waitForFinalEvent(function() {
//     hoemResizing = false;
//     smootherRef.paused(false);
//     scrollTriggerRef.enable();
//     scrollTriggerRef.refresh(); // jess: After resizing done, refresh the ScrollTrigger

//     hoemResizeDone(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }, 1000, 'hoemResize');
// }
// if(hoemIsSnippet) {
//   if(typeof hoemIsRevert !== 'undefined') window.removeEventListener('resize', hoemResizeHandlerRef);
//   window.hoemResizeHandlerRef = hoemResizeHandler;
//   window.addEventListener('resize', hoemResizeHandlerRef);
// }


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Control Key

// Play / Pause Elements animation
const hoemControlKey = (key) => {
  let opt = getComputedStyle(document.querySelector('.sector.email .butterfly-vector'))
    .getPropertyValue('--butterfly-play-state') === 'running' ? 'pause' : 'play'
  hoemElsControl(opt);
  console.log(`[home: email] [key: ${key} pressed] Elements animation: ${opt}`);
};

////////// Code for snippet
// const hoemControlKeyHandler = (e) => { if(e.key === '3') hoemControlKey(e.key); }
// if(hoemIsSnippet) {
//  if(typeof hoemIsRevert !== 'undefined') window.removeEventListener('keydown', hoemControlKeyHandlerRef);
//   window.hoemControlKeyHandlerRef = hoemControlKeyHandler;
//   window.addEventListener('keydown', hoemControlKeyHandlerRef);
// }


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// if(hoemIsSnippet) var hoemIsRevert = true;


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Export
export {
  hoemInit,
  hoemScrollMake,
  hoemScrollClear,
  hoemElsControl,
  hoemResizeStart,
  hoemResizeDone,
  hoemControlKey
}